module.exports = __webpack_public_path__ + "img/footer-content.ddf92748.png";